import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImplementerEmptyStatePage } from './implementer-empty-state-page';
import { ImplementerEmptyStateComponent } from '../implementer-empty-state-component/implementer-empty-state-component';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    ImplementerEmptyStatePage,
    ImplementerEmptyStateComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(ImplementerEmptyStatePage),
  ],
  exports: [
    ImplementerEmptyStateComponent
  ]
})
export class ImplementerEmptyStatePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-empty-state/implementer-empty-state/implementer-empty-state-page.module.ts